import React from "react";
import { Box } from "@mui/material";
import CardBrandIcon from "./CardBrandIcon";

/** Card networks shown side-by-side above the saved-cards block */
export const ACCEPTED_CARD_BRANDS = ["visa", "mastercard", "amex", "troy", "discover"];

/**
 * @param {object} props
 * @param {'block'|'inline'} [props.variant='block'] — inline: between text and checkbox in the payment gateway row
 */
function AcceptedCardBrandsStrip({ variant = "block" }) {
    const inline = variant === "inline";
    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: inline ? 0.5 : { xs: 0.75, sm: 1.25 },
                justifyContent: inline ? "center" : "flex-start",
                mb: inline ? 0 : 1.5,
                flex: inline ? "1 1 auto" : undefined,
                minWidth: 0,
                mx: inline ? { xs: 0.5, sm: 1 } : 0,
            }}
            aria-label="accepted-card-networks"
        >
            {ACCEPTED_CARD_BRANDS.map((b) => (
                <CardBrandIcon key={b} brand={b} size={inline ? "xs" : "small"} />
            ))}
        </Box>
    );
}

export default AcceptedCardBrandsStrip;
